import React from "react";
import { formatDate } from "../../utils/dates";
import { Link, useNavigate } from "react-router-dom";
import GenericAvatar from "../AIInbox/GenericAvatar";
import { getInitials } from "../../utils";
import Modal from "../../components/Modal";

const ItemModal = ({
  show,
  setIsModalVisible,
  singleTask,
  handleConversation,
}) => {
  const navigate = useNavigate();

  const viewConversation = () => {
    navigate(`/dashboard/ai-inbox?only=${singleTask?.task?.conversation_uuid}`);
  };

  const email = singleTask?.task?.resolver?.email;
  const firstName = singleTask?.task?.resolver?.first_name;
  const lastName = singleTask?.task?.resolver?.last_name;
  const isResolvedByAgent = !singleTask?.task?.resolver;
  const resolvedBy = isResolvedByAgent
    ? "AI Agent"
    : `${firstName} ${lastName}`;
  const initials = isResolvedByAgent ? "A" : getInitials(firstName, lastName);

  const taskSummary = singleTask?.task?.summary || "N/A";

  const [rawSummary, rawFollowUp] = taskSummary.split("\n\n");
  const summary = rawSummary?.replace("Summary: ", "");
  const followUp = rawFollowUp?.replace("Follow-up action: ", "");

  return (
    <Modal
      startIcon={
        <GenericAvatar
          firstName={singleTask?.task?.customer?.first_name}
          lastName={singleTask?.task?.customer?.last_name}
        />
      }
      open={show}
      onClose={() => setIsModalVisible(false)}
      title={`Ticket #${singleTask?.task?.conversation_id}`}
      description={formatDate(singleTask?.task?.last_message_time)}
      onSubmit={e => {
        e.preventDefault();
        handleConversation(singleTask?.task);
        setIsModalVisible(false);
      }}
      submitLabel={
        singleTask?.task?.resolved ? "Re-open Ticket" : "Close Ticket"
      }
    >
      <div>
        <div className="flex space-x-2 overflow-y-auto">
          <span
            className={`px-3 py-1 text-sm font-medium ${singleTask?.task?.resolved ? "bg-blue-100 text-blue-600" : "bg-orange-100 text-orange-600"} rounded-lg`}
          >
            {singleTask?.task?.resolved ? `Closed` : `Open`}
          </span>

          {[
            ...new Map(
              singleTask?.task?.intents.map(item => [item.type, item])
            ).values(),
          ].map((intent, index) => (
            <span
              key={`${intent.id}-${index}`}
              className="px-3 py-1 text-sm font-medium bg-green-100 text-green-700 rounded-lg"
            >
              {intent?.type}
            </span>
          ))}
        </div>

        <div className="mt-6">
          <h3 className="text-sm font-bold text-gray-700">
            Summary of Conversation
          </h3>
          <p className="text-sm text-gray-600 mt-1">{summary}</p>
        </div>

        <div className="mt-4">
          <h3 className="text-sm font-bold text-gray-700">Action</h3>
          <p className="text-sm text-gray-600 mt-1">{followUp}</p>
        </div>

        <div className="mt-4">
          <h3 className="text-sm font-bold text-gray-700">Data</h3>
          <ul className="mt-1 space-y-2">
            <li className="flex items-center text-sm text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                />
              </svg>
              <span className="ml-2">
                {singleTask?.task?.customer?.email || "N/A"}
              </span>
            </li>
            {/*<li className="flex items-center text-sm text-gray-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                <span className="ml-2">Last Order 143892</span>
              </li>*/}
          </ul>
        </div>

        <div className="mt-4">
          <h3 className="text-sm font-bold text-gray-700">User</h3>
          <div className="flex items-center mt-2">
            <div className="w-10 h-10 bg-gray-100 border border-gray-300 rounded-full flex items-center justify-center text-gray-600 font-medium">
              AL
            </div>
            <div className="ml-3 py-1 text-sm font-medium text-gray-700">
              <p className="text-sm font-semibold text-gray-900 leading-none">
                {singleTask?.task?.customer?.first_name +
                  " " +
                  singleTask?.task?.customer?.last_name}
              </p>
              <p className="text-sm text-gray-500 leading-none mt-0.5">
                {singleTask?.task?.customer?.email}
              </p>
            </div>
          </div>
        </div>

        {singleTask?.task?.resolved && (
          <div className="mt-4">
            <h3 className="text-sm font-bold text-gray-700">Closed By</h3>
            <div className="flex items-center mt-2">
              <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center text-gray-700 font-bold">
                {initials}
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-800">
                  {resolvedBy}
                </p>
                {Boolean(email) && (
                  <Link
                    className="text-sm text-gray-600"
                    target="_blank"
                    to={`mailto:${email}`}
                  >
                    {email}
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="mt-6">
          <button
            onClick={() => viewConversation()}
            className="w-full py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition duration-200 flex items-center justify-center space-x-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
              />
            </svg>
            <span>View Conversation</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ItemModal;
